import { AnimatePresence } from "framer-motion";
import { useCallback, useState } from "react";
import { TableContestProps } from "./table-contest-type";
import {  TableItemStyled, TextNumberPositionStyled, TextContainerStyled, IconContainerStyled, TableContainerStyled, ButtonCollapseContainerStyled } from "./style-component";
import { ExportOutlined, CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons";
import { formatAddress } from "@/utils/string/format";
import ReactionIcon from '@/assets/icons/heart.svg';
import ReachIcon from '@/assets/icons/megaphone.svg';
import CommentIcon from '@/assets/icons/message.svg';
import ShareIcon from '@/assets/icons/arrow-email-forward.svg';

const ICON = {
    GET_LIKES: ReactionIcon,
    GET_COMMENTS: ReachIcon,
    GET_SHARES: CommentIcon,
    GET_VIEWS: ShareIcon
}

const isValidUrl = (url: string) => {
    try {
        const newUrl = new URL(url);
        return newUrl.protocol === 'https:';
    } catch (e) {
        console.error(e);
        return false;
    }
};

const TableContest: React.FC<TableContestProps> = ({ items, userConnected }) => {
    const currentUser = userConnected ?? '';
    const [isCollapsed, setIsCollapsed] =  useState<boolean>(true);
    const selectedTarget = ICON['GET_LIKES'];
    
    const handleCollapse = useCallback(() => {
        setIsCollapsed(!isCollapsed);
    },[isCollapsed]);


    const handleGoToUrl = (url: string) => () => {
        if (isValidUrl(url)) {
            window.open(url, '_blank');
        }
    };

    function formatNumber(number: number) {
        if (typeof number !== 'number') {
            return number + '';
        }

        const abbreviations = [
            { value: 1E12, symbol: 'T' },
            { value: 1E9, symbol: 'B' },
            { value: 1E6, symbol: 'M' },
            { value: 1E3, symbol: 'k' }
        ];

        for (const { value, symbol } of abbreviations) {
            if (number >= value) {
                return (number / value).toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                }) + symbol;
            }
        }

        return number.toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        });
    }

    return (
    <>
        <TableContainerStyled
        initial={{ height: 0, opacity: 1 }} 
        animate={{ height: isCollapsed || items?.length <= 5 ? 400 : 620 }}
        exit={{ height: 0, opacity: 1 }}  
        transition={{ duration: 0.5 }}
        >
            <AnimatePresence>
                {items?.slice(0, isCollapsed ? 5 : items?.length).map((item, index) => {
                    const isCurrentUser = String(item?.user_main_key).toUpperCase() === String(currentUser).toUpperCase();
                    return (
                        <TableItemStyled
                            key={item?.user_main_key || index}
                            data-user-key={item?.user_main_key}
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.95 }}
                            layout
                            transition={{ duration: 0.5 }}
                            isCurrentUser={isCurrentUser || index === 0}
                            isFirstItem={index === 0}
                        >
                            <TextNumberPositionStyled $isCurrentUser={isCurrentUser}>{item?.current_position}</TextNumberPositionStyled>
                            <img
                                src={item?.profile_picture || item?.user_pic_url}
                                alt={item?.username || 'user'}
                                style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                            />
                            <TextContainerStyled>
                                <p>{String(userConnected).toUpperCase() === String(item.user_main_key).toUpperCase() ? 'Tú': formatAddress(item?.social_username || item?.username || '')}</p>
                                <IconContainerStyled>
                                    <img src={selectedTarget} alt="objective-icon" />
                                    <span>{formatNumber(item?.current_points)}</span>
                                </IconContainerStyled>
                            </TextContainerStyled>
                            <ExportOutlined style={{ color: 'inherit'}}  onClick={()=> handleGoToUrl(item?.url)}/>
                        </TableItemStyled>
                    );
                })}
            </AnimatePresence>
        </TableContainerStyled>
        {items?.length > 5 &&
        <ButtonCollapseContainerStyled  onClick={handleCollapse}>
            {!isCollapsed ? <CaretUpOutlined /> : <CaretDownOutlined />}
        </ButtonCollapseContainerStyled>}
    </>
    );
};

export default TableContest;
